export default {
  install(Vue) {
    Vue.prototype.$formatImageUrl = (url) => {
      if (url && /^http:\/\//.test(url)) {
        url = url.replace(/^http/, 'https')
      }

      return url
    }
  }
}
